module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANIAAAABCAYAAACrM/DDAAAAF0lEQVQ4T2M0X/P3P8MoGA2B0RCgKAQAbS4C4R5d8V4AAAAASUVORK5CYII="